import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Pagination from "../../ResuableCompoment/Pagination";
import SearchBar from "../../ResuableCompoment/SearchBar";
import useApi from "../../CustomHooks/useApi";
import { useSelector } from "react-redux";

const MerchantEdit = () => {
    const [loading, setLoading] = useState(true);
    const [formsData, setFormsData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [rawResponse, setRawResponse] = useState([]);
    const itemsPerPage = 10;

    const navigate = useNavigate();
    const userId = useSelector((state) => state.auth.employeeDetails.userId);

    const { callApi: pendingOnboard } = useApi(
        `/staff/onboard/get/update`,
        "GET"
    );

    useEffect(() => {
        fetchFormsData();
    }, []);

    const fetchFormsData = async () => {
        try {
            const response = await pendingOnboard(null, `?userId=${userId}`);
            setFormsData(response || []);
            setRawResponse(response || []);
            setLoading(false);
        } catch (err) {
            setLoading(false);
        }
    };

    const filteredForms = formsData.filter(
        (form) =>
            form.meta.fullName.toLowerCase().includes(searchQuery.toLowerCase()) ||
            form.role.toLowerCase().includes(searchQuery.toLowerCase()) ||
            form.mobileNumber.includes(searchQuery) ||
            form.userId.includes(searchQuery)
    );

    return (
        <div className="min-h-screen bg-[#EEF1F5] p-6">
            {/* Search */}
            <div className="mb-6">
                <SearchBar
                    placeholder="Search by Name, Role or Mobile"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </div>

            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="bg-white rounded-xl border border-gray-200 shadow-sm p-6"
            >
                {/* Heading */}
                <div className="mb-5 text-center">
                    <h2 className="text-lg font-semibold text-[#0A2A4F]">
                        Edit Merchant
                    </h2>
                </div>

                {/* Table */}
                {loading ? (
                    <p className="text-center text-gray-500">Loading...</p>
                ) : filteredForms.length === 0 ? (
                    <p className="text-center text-red-500">No data found</p>
                ) : (
                    <Pagination
                        items={filteredForms}
                        itemsPerPage={itemsPerPage}
                        currentPage={currentPage}
                        onPageChange={setCurrentPage}
                        renderItems={(currentItems) => (
                            <>
                                {/* ================= DESKTOP TABLE ================= */}
                                <div className="hidden md:block overflow-x-auto">
                                    <table className="min-w-full border border-gray-200 rounded-lg overflow-hidden">
                                        <thead className="bg-[#0A2A4F] text-white">
                                            <tr>
                                                {[
                                                    "Name",
                                                    "Mobile",
                                                    "PAN",
                                                    "Role",
                                                    "User ID",
                                                    "Onboarding Status",
                                                    "Action",
                                                ].map((h, i) => (
                                                    <th
                                                        key={i}
                                                        className="px-4 py-3 text-left text-sm font-medium"
                                                    >
                                                        {h}
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {currentItems.map((form, index) => (
                                                <tr
                                                    key={index}
                                                    className="border-b last:border-none hover:bg-gray-50 transition"
                                                >
                                                    <td className="px-4 py-3">{form.meta.fullName}</td>
                                                    <td className="px-4 py-3">{form.mobileNumber}</td>
                                                    <td className="px-4 py-3">{form.panCard}</td>
                                                    <td className="px-4 py-3">
                                                        <span className="px-2 py-1 rounded-full bg-slate-100 text-slate-700 text-xs">
                                                            {form.role}
                                                        </span>
                                                    </td>
                                                    <td className="px-4 py-3">{form.userId}</td>
                                                    <td className="px-4 py-3 text-sm">
                                                        {form.meta.Onboarding_status}
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <button
                                                            onClick={() =>
                                                                navigate("/OnboardingBasicDetails", {
                                                                    state: {
                                                                        form: rawResponse.find(
                                                                            (item) =>
                                                                                item.mobileNumber === form.mobileNumber
                                                                        ),
                                                                    },
                                                                })
                                                            }
                                                            className="px-4 py-1.5 rounded-lg text-sm bg-[#0A2A4F] text-white hover:bg-[#08305e]"
                                                        >
                                                            Open
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {/* ================= MOBILE CARD VIEW ================= */}
                                <div className="md:hidden space-y-4">
                                    {currentItems.map((form, index) => (
                                        <div
                                            key={index}
                                            className="bg-white border border-gray-200 rounded-xl shadow-sm p-4"
                                        >
                                            {/* Name + Role */}
                                            <div className="flex justify-between items-start mb-2">
                                                <h3 className="text-sm font-semibold text-[#0A2A4F]">
                                                    {form.meta.fullName}
                                                </h3>
                                                <span className="px-2 py-1 rounded-full bg-slate-100 text-slate-700 text-xs">
                                                    {form.role}
                                                </span>
                                            </div>

                                            {/* Details */}
                                            <div className="text-xs text-gray-600 space-y-1">
                                                <p><span className="font-medium">Mobile:</span> {form.mobileNumber}</p>
                                                <p><span className="font-medium">PAN:</span> {form.panCard}</p>
                                                <p><span className="font-medium">User ID:</span> {form.userId}</p>
                                                <p>
                                                    <span className="font-medium">Status:</span>{" "}
                                                    <span className="text-[#0A2A4F] font-medium">
                                                        {form.meta.Onboarding_status}
                                                    </span>
                                                </p>
                                            </div>

                                            {/* Button */}
                                            <div className="mt-3">
                                                <button
                                                    onClick={() =>
                                                        navigate("/OnboardingBasicDetails", {
                                                            state: {
                                                                form: rawResponse.find(
                                                                    (item) =>
                                                                        item.mobileNumber === form.mobileNumber
                                                                ),
                                                            },
                                                        })
                                                    }
                                                    className="w-full py-2 rounded-lg text-sm bg-[#0A2A4F] text-white hover:bg-[#08305e]"
                                                >
                                                    Open
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}
                    />
                )}
            </motion.div>
        </div>
    );
};

export default MerchantEdit;
